/** Mismo texto por defecto que backend `defaultTicketCloseMessage.ts` (setting `ticketCloseMessageText`). */
export const DEFAULT_TICKET_CLOSE_MESSAGE =
  "💬⚙️ *Ticket de Atención:* {nroticket} 😀 ya fue cerrada correctamente... El bot 🤖 se volvera activar en *5 minutos*";
